import React from 'react';
import { Card } from './Card';

export const Modal = ({ isOpen, onClose, title, children, maxWidthClass = 'max-w-lg' }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <Card className={`w-full ${maxWidthClass} mx-4 relative animate-in fade-in zoom-in duration-200`}>
        <div className="flex justify-between items-center mb-4 border-b border-slate-100 pb-3">
          <h3 className="text-lg font-bold text-eddp-dark">{title}</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-red-500">
            ✕
          </button>
        </div>
        {children}
      </Card>
    </div>
  );
};
